import {qspost} from '@/plugins/axios'

/*
 * 小区列表
 * @constructor jack
 * */
export const xiaoQuList = (searchName,status, page, pageSize) => qspost('/Index/Xiaoqu/xiaoQuList', {
  searchName,status, page, pageSize
})

/*
 * 获取社区负责的项目
 * @constructor jack
 * */
export const xiangMuByXiangMuJingLi = () => qspost('/Index/Xiaoqu/xiangMuByXiangMuJingLi', {})

/*
 * 添加/修改 小区
 * @constructor jack
 * */
export const xiaoQuAdd = (xiangmuId,name,shengId,shengName,shiId,shiName,quId,quName,address,beizhu,id) => qspost('/Index/Xiaoqu/xiaoQuAdd', {
  xiangmuId,name,shengId,shengName,shiId,shiName,quId,quName,address,beizhu,id
})

/*
 * 小区状态修改
 * @constructor jack
 * */
export const setXiaoQuStatus = (xiaoquId,status) => qspost('/Index/Xiaoqu/setXiaoQuStatus', {xiaoquId,status})


/*
 * 楼栋列表
 * @constructor jack
 * */
export const louList = (xiaoQuId,xiangMuId) => qspost('/Index/Xiaoqu/louList', {xiaoQuId,xiangMuId})

/*
 * 楼栋添加/修改
 * @constructor jack
 * */
export const louAdd = (xiaoQuId,xiangMuId,name,id) => qspost('/Index/Xiaoqu/louAdd', {xiaoQuId,xiangMuId,name,id})

export const louDel = (id) => qspost('/Index/Xinxuqiu/delBuilding', {id})








/*
 * 门户（单元、房间号）列表
 * @constructor jack
 * */
export const menHuList = (buildingId,xiaoQuId,xiangMuId) => qspost('/Index/Xiaoqu/menHuList', {buildingId,xiaoQuId,xiangMuId})

/*
 * 门户（单元、房间号）添加
 * @constructor jack
 * */
export const menHuAdd = (buildingId,menJsonStr) => qspost('/Index/Xiaoqu/menHuAdd', {buildingId,menJsonStr})

/*
 * 户（房间号）修改名称
 * @constructor jack
 * */
export const huUpdate = (roomId,name,status) => qspost('/Index/Xiaoqu/huUpdate', {roomId,name,status})


/*
 * 门（单元）修改
 * @constructor jack
 * */
export const menUpdate = (elementId,name) => qspost('/Index/Xiaoqu/menUpdate', {elementId,name})

/*
 * 小区列表 —— By项目主键
 * @constructor jack
 * */
export const xiaoQuListByXiangMuId = (xiangMuId) => qspost('/Index/Xinxuqiu/getLouMenListByXiangMuId', {xiangMuId})

/*
 * 楼门列表 —— By小区主键
 * @constructor jack
 * */
export const getLouMenListByXiaoQuId = (xiaoQuId) => qspost('/Index/Xiaoqu/getLouMenListByXiaoQuId', {xiaoQuId})

